// import BrowserHelper from "@/_helpers/browser/browser-helper";
// let browserHelper = new BrowserHelper();

import {
    getDecimalFormat, getGlobalField,
    getDefaultUserSettings,
    getDefaultCustomerSettings,
} from "../_store/helpers"
import { DataGridState } from "../_models/data-grid-state";
import ColumnWidth from "../_helpers/data-grid/ColumnWidth";

export default {
    props: {},
    data() {
        return {

        };
    },
    watch: {
    },
    computed: {
    },
    async created() {
    },
    methods: {
        addGridNoResults(e, noDataMessageOverride) {
            if (!e) return;
            setTimeout(() => {
                var data = undefined;

                if (
                    noDataMessageOverride &&
                    !e.component.state().searchText &&
                    !this.isAdvanceFilterApplied
                ) {
                    data = noDataMessageOverride.addNew;
                } else if (
                    this.noDataMessage &&
                    !e.component.state().searchText &&
                    !this.isAdvanceFilterApplied
                ) {
                    data = this.noDataMessage.addNew;
                } else
                    data = {
                        class: "no-data",
                        title: "Uh-oh!",
                        message:
                            "We are struggling to find what you are looking for. Try altering your search criteria",
                    };

                let masterDetails = e.element.querySelector(".dx-master-detail-row");
                let noData = e.element.querySelector(
                    ".dx-datagrid-nodata:not(.dx-hidden)"
                );

                let gridContentArea = e.element.querySelector(".dx-datagrid-rowsview");

                if (noData && gridContentArea && gridContentArea.clientHeight < 265) {
                    data.class = data.class + " hide";
                }

                if (this.formsConfig)
                    this.formsConfig.dataGridForNoData = e;
                if (noData && masterDetails == null) {
                    noData.innerHTML = `<div class="content-block home-content" ref="home-content">
          <img class="${data.class}" width="300" />
          <div class="details-div">
         <span class='oops'>${data.title}</span>
            <p class="p-details">
            ${data.message}
          </p>
          </div>
        </div>`;
                }
            }, 200);
        },

        parseGridColumns(columnInfo) {
            // transform incoming columns to dev express columns
            let gridColumnsArray = columnInfo
                .map((c) => {
                    let globalField = getGlobalField(c.screenField);

                    return { ...globalField, ...c }; // merge global field and the column definition
                })
                .filter((x) => x.dataField != null) // TODO: correct this condition to accommodate all valid columns
                .map((x) => {
                    let column = this.parseColumn(x);
                    return column;
                });

            // add pad column based on prop value
            if (this.padColumn) {
                gridColumnsArray.push({
                    label: "",
                    dataField: "",
                    width: 5,
                    minWidth: 5,
                    type: "String",
                    columnMinWidth: 5,
                    fixed: true,
                    fixedPosition: "right",
                    allowExporting: false,
                    allowGrouping: false,
                    allowHiding: false,
                    showInColumnChooser: false,
                });
            }

            if (
                this.persistenceKey &&
                DataGridState.isAvailable(this.persistenceKey)
            ) {
                var columns = DataGridState.getColumns(
                    this.persistenceKey,
                    this.appendHiddenColumns(gridColumnsArray)
                );
                return columns;
            } else return this.appendHiddenColumns(gridColumnsArray);
        },
        parseColumn(x) {
            let columnResult = {
                caption: x.gridLabel
                    ? x.gridLabel : x.caption ? x.caption
                        : x.label instanceof Function
                            ? x.label()
                            : x.label,

                dataField: x.gridDataField ? x.gridDataField : x.dataField,
                minWidth: x.minWidth ? x.minWidth : x.width ? x.width : 200,
                visible: x.visible,
                cellTemplate: x.cellTemplate,
                cellTemplateRecord: x.cellTemplateRecord,
                exportFields: x.exportFields,
                allowGrouping: x.allowGrouping,
                sortOrder: x.sortOrder,
                sortIndex: x.sortIndex,
                calculateSortValue: x.calculateSortValue,
                allowEditing: x.allowEditing == undefined ? false : x.allowEditing,
                allowHiding: x.allowHiding,
                allowSearch: x.allowSearch == false ? x.allowSearch : true,
                showInColumnChooser:
                    x.showInColumnChooser == false ? x.showInColumnChooser : true,
                headerCellTemplate: x.headerCellTemplate,
                allowSorting: x.allowSorting == false ? x.allowSorting : true,
                defaultValue: x.defaultValue,
                makeReadOnly: x.makeReadOnly,
                makeDisabled: x.makeDisabled,
                valueChangeCallBack: x.valueChangeCallBack,
                showEditorAlways: x.showEditorAlways,
                hyperlink: x.hyperlink,
                gridUrlDataField: x.gridUrlDataField,
                gridUrlConditions: x.gridUrlConditions,
                cssClass: x.cssClass ? x.cssClass : undefined,
                globalField: x.dataField,
                screenField: x.fieldName,
                customTemplate: x.customTemplate,
                displayValue: x.displayValue,
                alignment: x.alignment != undefined ? x.alignment : undefined,
                editCellTemplate: x.editCellTemplate ? x.editCellTemplate : undefined,
                groupCellTemplate: x.groupCellTemplate
                    ? x.groupCellTemplate
                    : undefined,
                customCellDataField: x.customCellDisplayField
                    ? x.customCellDisplayField
                    : undefined,
                dataType: x.type == "String" ? "string" : undefined,
                filterDataField: x.filterDataField,
                format: x.format,
                hyperLinkDataField: x.hyperLinkDataField,
                minmax: x.minmax,
                calculateCellValue: x.calculateCellValue
                    ? x.calculateCellValue
                    : undefined,
                customFilter: x.customFilter ? x.customFilter : undefined,
                editorOptions: x.editorOptions,
                allowUpdate: x.allowUpdate,
                activeHyperLink: x.activeHyperLink ? x.activeHyperLink : undefined,
                customHyperLink: x.customHyperLink ? x.customHyperLink : undefined,
                dataPath: x.dataPath,

                makeAcceptCustomValue: x.makeAcceptCustomValue
                    ? x.makeAcceptCustomValue
                    : undefined,
                onCustomItemCreating: x.onCustomItemCreating
                    ? x.onCustomItemCreating
                    : undefined,
                filterDefaultValue: x.filterDefaultValue,
                onKeyDown: x.onKeyDown ? x.onKeyDown : undefined,
                lookup: x.lookup ? x.lookup : undefined,
                validationRules: x.validationRules ? x.validationRules : undefined,
                setCellValue: x.setCellValue ? x.setCellValue : undefined,
                editorType: x.editorType ? x.editorType : undefined,
                calculateDisplayValue: x.calculateDisplayValue ? x.calculateDisplayValue : undefined,
                buttons: x.buttons ? x.buttons : undefined,
                type: x.type ? x.type : undefined,
                calculateGroupCellDisplayValue: x.calculateGroupCellDisplayValue
                    ? x.calculateGroupCellDisplayValue
                    : undefined,
                rowColorNegative:
                    x.rowColorNegative != undefined ? x.rowColorNegative : false,
            };

            if (x.visibleIndex) {
                columnResult.visibleIndex = x.visibleIndex;
            }
            if (!columnResult.editorOptions) columnResult.editorOptions = {};

            if (x.columns) {
                columnResult.columns = x.columns
                    .map((c) => {
                        let globalField = getGlobalField(c.screenField);

                        return { ...globalField, ...c }; // merge global field and the column definition
                    })
                    .filter((x) => x.dataField != null) // TODO: correct this condition to accommodate all valid columns
                    .map((x) => {
                        let column = this.parseColumn(x);
                        return column;
                    });
            }

            if (x.fixed) {
                columnResult.fixed = x.fixed;
                columnResult.fixedPosition = x.fixedPosition;
                columnResult.allowReordering = false;
            }
            if (x.ApplicationFeatureCode)
                columnResult.ApplicationFeatureCode = x.ApplicationFeatureCode;
            if (x.reportDataField) columnResult.reportDataField = x.reportDataField;

            if (x.groupIndex != undefined) {
                columnResult.groupIndex = x.groupIndex;
            }

            if (x.type === "Date") {
                columnResult.dataType = "date";
                columnResult.format = "dd MMM yyyy";
                columnResult.minWidth = 100;
                columnResult.width = 100;
                if (x.width) columnResult.width = x.width;
                if (x.minWidth) columnResult.minWidth = x.minWidth;
                if (x.editable != undefined) columnResult.editable = x.editable;
            }

            if (x.type === "Time") {
                columnResult.dataType = "datetime";
                columnResult.format = "H:mm aa";
                columnResult.width = 150;
                columnResult.minWidth = 150;
                if (x.editable != undefined) columnResult.editable = x.editable;
            }

            if (x.type === "Integer") {
                columnResult.alignment = x.alignment || "left";
                if (x.width && x.width > 0) {
                    columnResult.width = x.width; // GCS-ChipWidth
                    columnResult.minWidth = x.width;
                }

                if (columnResult.format) {
                    columnResult.format = getDecimalFormat(x.format).ReadOnlyFormat;
                    if (x.allowEditing) {
                        columnResult.editorOptions.format = getDecimalFormat(
                            x.format
                        ).EditFormat;
                        columnResult.editorOptions.step = 0;
                    }
                }
            }

            if (
                columnResult.cellTemplate === "Status" ||
                columnResult.cellTemplate === "ActiveStatus"
            ) {
                columnResult.width = 100; // GCS-ChipWidth
                columnResult.minWidth = 100;
                columnResult.allowEditing = false;
                columnResult.allowFiltering = true;

                columnResult.fixed = x.fixed != undefined ? x.fixed : true; // GCS-ChipFixedRight //HACK: Tablet scrolling doesnt worked on fixed columns
                columnResult.fixedPosition = "right"; // GCS-ChipFixedRight
                columnResult.alignment = "left"; // GCS-ChipAlignment
                columnResult.allowReordering = false;
                columnResult.showInColumnChooser = false;
            }

            if (x.type === "Decimal") {
                columnResult.caption = columnResult.caption.replace(
                    "(Base Currency)",
                    `(${getDefaultUserSettings().CurrencyCode})`
                );
                columnResult.format = getDecimalFormat(x.format).ReadOnlyFormat;
                columnResult.alignment = "right";
                if (x.width && x.width > 0) {
                    columnResult.width = x.width; // GCS-ChipWidth
                    columnResult.minWidth = x.width;
                } else {
                    columnResult.width = getDecimalFormat(x.format).Width;
                    columnResult.minWidth = getDecimalFormat(x.format).Width;
                }

                if (x.cellTemplate != false) columnResult.cellTemplate = "Decimal";

                columnResult.caption = columnResult.caption.replace(
                    "(Customer Currency)",
                    `(${getDefaultCustomerSettings().CustomerCurrency
                        ? getDefaultCustomerSettings().CustomerCurrency
                        : ""
                    })`
                );

                if (x.allowEditing) {
                    columnResult.editorOptions.format = getDecimalFormat(
                        x.format
                    ).EditFormat;
                    columnResult.editorOptions.step = 0;
                }
            }
            if (x.type === "EditableDecimal") {
                if (columnResult.caption) {
                    columnResult.caption = columnResult.caption.replace(
                        "(Base Currency)",
                        `(${getDefaultUserSettings().CurrencyCode})`
                    );
                    columnResult.caption = columnResult.caption.replace(
                        "(Customer Currency)",
                        `(${getDefaultCustomerSettings().CustomerCurrency
                            ? getDefaultCustomerSettings().CustomerCurrency
                            : ""
                        })`
                    );
                }

                if (x.format) {
                    columnResult.format = getDecimalFormat(x.format).EditFormat;
                    columnResult.width = getDecimalFormat(x.format).Width;
                }
                columnResult.alignment = "right";
                columnResult.editCellTemplate = "EditableDecimal";
            }

            if (x.type == "DefaultDecimal") {
                columnResult.caption = columnResult.caption.replace(
                    "(Base Currency)",
                    `(${getDefaultUserSettings().CurrencyCode})`
                );

                if (x.allowEditing) {
                    columnResult.editorOptions.format = getDecimalFormat(
                        x.format
                    ).EditFormat;
                    // columnResult.editorOptions.onFocusIn = (e) => {
                    //   e.event.target.select();
                    // };
                    columnResult.editorOptions.step = 0;
                } else {
                    columnResult.format = getDecimalFormat(x.format).EditFormat;
                }
                columnResult.alignment = "right";
                columnResult.width = getDecimalFormat(x.format).Width;
                columnResult.cssClass = "edit-cell-numberbox-field";
                columnResult.dataType = "number";
            }

            if (x.type == "GridRecordEllipsisMenu") {
                columnResult.minWidth = 75;
                columnResult.width = 75;
                columnResult.fixed = x.fixed;
                columnResult.fixedPosition = x.fixedPosition;
                columnResult.ellipsisMenu = x.ellipsisMenu;
            }

            if (x.cellTemplateRecord)
                if (x.cellTemplateRecord.image) {
                    columnResult.minWidth = 250;
                    columnResult.alignment = "left";
                    if (this.id == "grid-report-grid")
                        columnResult.cellTemplateRecord.image = undefined;
                }

            if (x.type == "radio") {
                columnResult.minWidth = 75;
                columnResult.width = 75;
            }

            if (x.type == "Checkbox") {
                columnResult.width = x.width ? x.width : undefined;
                columnResult.minWidth = x.width ? x.width : columnResult.minWidth;
            }

            if (x.hyperlink && x.cellTemplate != "Record") {
                columnResult.cellTemplate = "Hyperlink";
            }

            if (
                x.cellTemplate == "SelectField" ||
                x.editCellTemplate == "SelectField"
            ) {
                columnResult.editorData = [
                    {
                        dataSourceConfig: x.dataSourceConfig,
                        editorTemplate: x.editorTemplate,
                        valueExpr: x.valueExpr,
                        displayExpr: x.displayExpr,
                        dataField: x.dataField,
                        formLocation: "data-grid",
                        readOnly: x.readOnly,
                        fieldTemplate: x.fieldTemplate ? x.fieldTemplate : undefined,
                        dropDownOptions: x.dropDownOptions ? x.dropDownOptions : undefined,
                        editorOptions: x.editorOptions ? x.editorOptions : undefined,
                        validationRules: x.validationRules,
                        searchExpr: x.searchExpr,
                        makeAcceptCustomValue: x.makeAcceptCustomValue,
                        onCustomItemCreating: x.onCustomItemCreating,
                    },
                ];
            }

            if (x.type == "RecordButton") {
                columnResult.width = 50;
                columnResult.minWidth = 50;
                columnResult.fixed = x.fixed;
                columnResult.fixedPosition = x.fixedPosition;
                if (x.ellipsisMenu) columnResult.ellipsisMenu = x.ellipsisMenu;
                if (x.menuItems) columnResult.menuItems = x.menuItems;
                if (x.PrintPreview) columnResult.PrintPreview = x.PrintPreview;
                if (x.BackgroundPrint) columnResult.BackgroundPrint = x.BackgroundPrint;
                if (x.BackgroundEmail) columnResult.BackgroundEmail = x.BackgroundEmail;
                if (x.ReferenceNoField)
                    columnResult.ReferenceNoField = x.ReferenceNoField;
                if (x.ReferenceNoFields)
                    columnResult.ReferenceNoFields = x.ReferenceNoFields;
                if (x.DeleteOptions) columnResult.DeleteOptions = x.DeleteOptions;
            }

            if (x.width) columnResult.width = x.width;
            if (x.minWidth) columnResult.minWidth = x.minWidth;

            if (x.customTemplate) columnResult.cellTemplate = "Custom";
            if (
                x.allowHiding == false &&
                (x.fixedPosition != "right") & (x.type != "Checkbox")
            )
                columnResult.width = undefined;

            // columnResult.cellTemplate = undefined;
            if (
                columnResult.width &&
                this.baseView.mode != "create" &&
                this.baseView.mode != "edit"
            )
                columnResult.renderAsync = true;

            if (x.dataType) {
                columnResult.dataType = x.dataType;
            }

            columnResult.name = columnResult.caption;
            if (x.name) columnResult.name = x.name;

            // console.log("ZZZZ ", columnResult);

            if (
                columnResult.dataField == "ActionDelete" ||
                columnResult.dataField == "ActionAddNew" ||
                columnResult.dataField == "ActionCopy"
            ) {
                columnResult.allowFiltering = false;
                columnResult.allowSearch = false;
                columnResult.allowSorting = false;
                columnResult.allowHiding = false;
                columnResult.allowGrouping = false;
                columnResult.allowUpdate = false;
            }

            // console.log(">>>> ", columnResult);

            if (
                this.id == "transaction-list-grid" ||
                this.id == "grid-report-grid" ||
                this.id == "split-view-grid"
            ) {
                if (
                    columnResult.cellTemplate &&
                    columnResult.cellTemplate == "Record"
                ) {
                    columnResult.cellTemplate = "GcRecordCell";
                }
            }

            if (
                columnResult.screenField == "GridRecordEmail" ||
                columnResult.screenField == "GridRecordPDFView" ||
                columnResult.screenField == "GridRecordPrint" ||
                columnResult.screenField == "GridRecordEllipsisMenu"
            ) {
                columnResult.minWidth = 30;
                columnResult.width = 30;
                columnResult.cssClass = "padding-0";

                if (x.dropDownOptions) columnResult.dropDownOptions = x.dropDownOptions;
            }

            if (x.maxWidth > 0) {
                columnResult.width = x.maxWidth;
                columnResult.minWidth = x.maxWidth;
            }

            if (x.editorType) {
                columnResult.editorType = x.editorType;
                if (x.setCellValue) columnResult.setCellValue = x.setCellValue;
            }

            if (x.lookup) {
                if (x.setCellValue) columnResult.setCellValue = x.setCellValue;
            }

            if (x.type == "buttons") {
                columnResult.type = x.type;
                if (x.buttons) columnResult.buttons = x.buttons;
            }

            if (this.id == "grid-report-grid") {
                columnResult.groupCellTemplate = "group-cell-template";
            }

            return columnResult;
        },
        appendHiddenColumns(columns) {
            let hiddenColumns = [];
            columns.forEach((col) => {
                if (col.exportFields && col.exportFields.length > 0) {
                    col.exportFields.forEach((f) =>
                        hiddenColumns.push({
                            caption: f.label instanceof Function ? f.label() : f.label,
                            type: col.type,
                            dataField: f.dataField,
                            width: 200,
                            visible: false,
                            showInColumnChooser:
                                col.showInColumnChooser == false
                                    ? col.showInColumnChooser
                                    : f.showInColumnChooser == false
                                        ? false
                                        : true,
                            allowSearch:
                                col.allowSearch == false
                                    ? col.allowSearch
                                    : f.allowSearch == false
                                        ? false
                                        : true,
                            name: f.label,
                        })
                    );
                }
            });

            columns.push(...hiddenColumns);

            return columns;
        },
        getSelectFields(columns) {
            var select = [];
            columns.forEach((e) => {
                if (e.select != false) {
                    let globalField = getGlobalField(e.screenField);
                    if (!e.gridDataField && !e.dataField) {
                        if (globalField.gridDataField) select.push(globalField.gridDataField);
                        else if (globalField.dataField) select.push(globalField.dataField);
                    } else {
                        if (e.gridDataField) select.push(e.gridDataField);
                        if (e.dataField) select.push(e.dataField);
                    }

                    if (e.filterDataField) select.push(e.filterDataField);
                    else if (globalField.filterDataField) select.push(globalField.filterDataField);

                    var exportFields = { ...globalField, ...e }.exportFields;

                    if (exportFields) {
                        exportFields.forEach((ex) => {
                            if (select.findIndex((i) => i == ex.dataField) == -1) {
                                select.push(ex.dataField);
                            }
                        })
                    }
                }
            });

            return select;
        },

        getColumnWidth(Column) {
            return ColumnWidth.getValue(Column).width;
        },
        getColumnMinWidth(Column) {
            return ColumnWidth.getValue(Column).minWidth;
        },

        parseColumnWithScreenFields(columnInfo) {
            let gridColumnsArray = columnInfo
                .map((c) => {
                    let globalField = getGlobalField(c.screenField);
                    let column = undefined;

                    if (globalField) {
                        if (!c.caption && globalField.label) c.caption = globalField.label;

                        column = { ...globalField, ...c };
                    } else column = c;

                    const regex = /\bDecimal\b/;
                    if (column.format && regex.test(column.format)) {
                        column.format = getDecimalFormat(column.format).EditFormat;
                        if (column.cellTemplate != false) column.cellTemplate = "Decimal";
                    }


                    return column;
                })
                .filter((x) => x.dataField != null);

            return gridColumnsArray;
        }
    },
};
